//Libraries
import React, { Component } from 'react';

import { Badge, 
    Input, InputGroup,
 } from 'reactstrap';


class FileInputComponent extends Component {


  render() {
        return(
            <div style = {{flexDirection:'row', display:'flex'}}>
                <h4 style = {{width:'20%'}}>
                    <Badge color = {this.props.BadgeColor || "primary"}>{this.props.Title}</Badge>
                </h4>
                <div style = {{width:'80%'}}>
                    <form >
                        <input type="file" onChange= {(f) => {
                            this.props.OnSelect(f)
                            }} />
                    </form> 
                </div>
            </div>
        )
    }
}

export default FileInputComponent